(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  function reveal(scope = document) {
    const elements = [...scope.querySelectorAll('[data-soyul-reveal]:not(.is-visible)')];
    if (!elements.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      elements.forEach(el => el.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    }), {rootMargin:'0px 0px -8% 0px', threshold:.08});
    elements.forEach(el => observer.observe(el));
  }
  function cartMotion(scope = document) {
    scope.querySelectorAll('.cart-page').forEach(cart => {
      if (cart.dataset.finishReady) return;
      cart.dataset.finishReady = 'true';
      const total = cart.querySelector('[data-cart-subtotal]');
      if (!total) return;
      let previous = total.textContent.trim();
      new MutationObserver(() => {
        const next = total.textContent.trim();
        if (!next || next === previous) return;
        previous = next;
        total.classList.remove('is-updated');
        requestAnimationFrame(() => total.classList.add('is-updated'));
      }).observe(total, {subtree:true, childList:true, characterData:true});
    });
  }
  function cardSwaps(scope = document) {
    scope.querySelectorAll('.soyul-card-swap').forEach(card => {
      if (card.dataset.swapReady || !card.querySelector('.soyul-card-swap__secondary')) return;
      card.dataset.swapReady = 'true';
      let timer;
      const clearPreview = () => {
        card.classList.remove('is-previewing');
        clearTimeout(timer);
      };
      card.addEventListener('touchstart', () => {
        document.querySelectorAll('.soyul-card-swap.is-previewing').forEach(other => {
          if (other === card) return;
          other.classList.remove('is-previewing');
        });
        card.classList.add('is-previewing');
        clearTimeout(timer);
      }, {passive:true});
      // A normal tap must always keep the native product link. The secondary
      // photo is only a short tactile preview while the finger is on the card.
      card.addEventListener('touchend', () => {
        timer = setTimeout(clearPreview, 220);
      }, {passive:true});
      card.addEventListener('touchcancel', clearPreview, {passive:true});
    });
  }
  function init(scope = document) { reveal(scope); cartMotion(scope); cardSwaps(scope); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
